import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Call } from '@angular/compiler';
import { UrlString } from '@azure/msal-browser';
import { catchError, map, Observable, throwError } from 'rxjs';
//import { } from '@angular/fire';

const httpOptions = {
  headers: new HttpHeaders({
      'Content-Type': 'application/json'
  })
};

const httpStreamOptions = {
  headers: new HttpHeaders(
    {
      "content-type": "application/text",
      'Accept': 'application/text',
      'responseType':'application/text',
      "observe": "response"
      // 'Access-Control-Allow-Headers': 'Content-Type',
      // 'Access-Control-Allow-Methods': 'GET',
      // 'Access-Control-Allow-Origin': '*',
    },
  )
};

@Injectable({
  providedIn: 'root'
})

export class ApiService {
  //private baseApiUrl = 'https://web01cdev.browardschools.com/BCPSWebApiServices/api';
  //private baseApiUrl_sbbcpolicy = 'https://web01cdev.browardschools.local/bcpswebapidmzproxy/api/schoolboardpolicies';
  private baseApiUrl_sbbcpolicypdf = 'https://web01cdev.browardschools.local/bcpswebext/api';
  private baseApiUrl_sbbcpolicy = 'https://schoolinfo.browardschools.com/bcpswebapiproxy/api/schoolboardpolicies';
  //private baseUploadApiUrl_sbbcpolicy = 'https:/localhost:7169/api/fileupload';
  private baseUploadApiUrl_sbbcpolicy = 'https://web01cdev.browardschools.local/bcpswebapiinternal/api/fileupload';
  //private baseApiUrl_sbbcpolicy = 'https://localhost:44307/api/SchoolboardPolicies'; //'https://web01cdev.browardschools.com/bcpswebapi/api/schoolboardpolicies';
  //private baseApiUrl_princiapl = 'https://localhost:7169/api/SchoolsMaster'; //'https://web01cdev.browardschools.com/bcpswebapi/api/schoolboardpolicies';
  private baseApiUrl_princiapl = 'https://web01cdev.browardschools.local/bcpswebapi/api/SchoolMaster';
  private baseApiUrl_smm = 'https://web01cdev.browardschools.com/BCPSWebApi/smm'; //'https://localhost:44307/smm';
  private baseIpInfoUrl = 'https://api.ipgeolocation.io/ipgeo?apiKey=db01e6147367479eb964a67be8c4ff12&fields=geo&include=hostname';
  private callURL = '';

  constructor(private httpClient: HttpClient) { }

  public getJsonRestApi(url, apiBaseName) {
    if (apiBaseName == 'Schoolboard Policy') {
      this.callURL = this.baseApiUrl_sbbcpolicy + url;
    }
    else if (apiBaseName == 'Software Request') {
      this.callURL = this.baseApiUrl_smm + url;
    }
    else if (apiBaseName == 'School Info') {
      this.callURL = this.baseApiUrl_sbbcpolicy + url;
    }
    else if (apiBaseName == 'Schools Master') {
      this.callURL = this.baseApiUrl_princiapl + url;
    }
    else {
      this.callURL = url;
    }
    // return this.httpClient.get(this.callURL).pipe(
    //   map(data => {
    //     return data;
    //   }),
    console.log("callURL: " + this.callURL);
    return this.httpClient.get(
        this.callURL,
        {headers : new HttpHeaders({
          'Content-Type': 'application/json'
        })})
      .pipe(
      map(data => {
        //console.log("in api call data: " + JSON.stringify(data));
        return data;
      }),
      catchError(error => {
        return throwError(error); 
      })
    );
  }

  public postJsonRestApi(url, apiBaseName, content) {
    if (apiBaseName == 'Schoolboard Policy') {
      this.callURL = this.baseApiUrl_sbbcpolicy + url;
    }
    else if (apiBaseName == 'Software Request') {
      this.callURL = this.baseApiUrl_smm + url;
    }
    else if (apiBaseName == 'School Info') {
      this.callURL = this.baseApiUrl_sbbcpolicy + url;
    }
    else if (apiBaseName == 'Schools Master') {
      this.callURL = this.baseApiUrl_princiapl + url;
    }
    else {
      this.callURL = url;
    }
    console.log("post api call: " + this.callURL);
    return this.httpClient.post(
        this.callURL,
        JSON.stringify(content),
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
      )
      .pipe(
        map(data => {
          return data;
        } 
      ),
      catchError(error => {
        return throwError(error); 
      })
    );
  }

  public uploadFile (apiUrl, theFile, formData) {
    apiUrl = this.baseUploadApiUrl_sbbcpolicy + apiUrl;
    return this.httpClient.post(apiUrl, formData)
    .pipe(
      map( data => {
        console.log("upload file return data: " + JSON.stringify(data)); 
        return data; 
      }),
      catchError(e => {
        return throwError(e)})
    )
    catchError((e) => {
      return throwError(e)
    });
  }

  public getPDFStream (url) {
    let apiCall = this.baseApiUrl_sbbcpolicy + url;
    console.log("apiCall: " + apiCall);
    return this.httpClient.get(apiCall
            //, { responseType: "text" }
            , httpStreamOptions
      ).pipe(
      map( data => {
        console.log("data after get:" + JSON.stringify(data));
        //var anonymous = <any>data;

        //console.log("data after anonymous.body:" + JSON.stringify(anonymous.body));
        return data;
        //return anonymous.body;
      }),
      catchError(
        e => {
          console.log("error in data blob: " + JSON.stringify(e));
          return throwError(e)
        }
      )
    );
  }

  public getPDFStream_CharterSchool(url) {
    //let apiCall = this.sanitizer.bypassSecurityTrustResourceUrl(this.baseApiUrl_sbbcpolicy + url);
    let apiCall = this.baseApiUrl_sbbcpolicypdf + url;
    console.log("apiCall: " + apiCall);
    return this.httpClient.get(apiCall
            , { responseType: "blob" }
            //, httpStreamOptions
      ).pipe(
      map( data => {
        console.log("data after get:" + JSON.stringify(data));
        //var anonymous = <any>data;

        //console.log("data after anonymous.body:" + JSON.stringify(anonymous.body));
        return data;
        //return anonymous.body;
      }),
      catchError(
        e => {
          console.log("error in data blob: " + JSON.stringify(e));
          return throwError(e)
        }
      )
    );
  }
}
